import { setTheme } from "theme/default/setTheme";

export const setColor_rgba_0_131_245_67 = setTheme(({ theme }) => `color: ${theme.colors.color_rgba_0_131_245_67}`);
